import type { TrackEventBodyWeb } from '@bridebook/toolbox/src/types';
import { getMetaCapiMetadata } from '@bridebook/web/lib/analytics-utils/get-meta-capi-metadata';
import { CriticalWebEvents } from '@bridebook/web/lib/analyticsTypes';
import { fetchy } from '@bridebook/web/lib/fetchy';
import getServerSideAnalyticsProps from '@bridebook/web/lib/utils/get-server-side-analytics-props';
import type { IServerSideTrack } from '@bridebook/web/lib/utils/server-side-track';
import { IApplicationState } from '@bridebook/web/lib/types';

/**
 * Helper for enriching the specificEventProps with Meta CAPI metadata for the "Emailed supplier" event.
 */
const enrichSpecificEventProps = async (
  specificEventProps: IServerSideTrack['specificEventProps'],
  state: IApplicationState,
) => {
  const metaCapiMetadata = await getMetaCapiMetadata(state);
  return {
    ...specificEventProps,
    userEmail: state.users.user?.contacts?.email,
    os: metaCapiMetadata.os,
    adTrackingEnabled: metaCapiMetadata.advertiserTrackingStatus === 'authorized',
  };
};

const enquirySupplierTrack = async ({
  state,
  event,
  identifyProps,
  specificEventProps,
  contactedSupplier,
  category = '',
}: IServerSideTrack) => {
  const enrichedSpecificEventProps =
    event === CriticalWebEvents.EMAILED_SUPPLIER
      ? await enrichSpecificEventProps(specificEventProps, state)
      : specificEventProps;

  const body: TrackEventBodyWeb = {
    event,
    identifyProps,
    genericProps: getServerSideAnalyticsProps(state),
    specificEventProps: enrichedSpecificEventProps,
    source: 'web',
    contactedSupplier,
    category,
  };

  return fetchy().post('/api/a/t/enquiry', null, body);
};

export default enquirySupplierTrack;
